import React from 'react';
import { Button } from 'components/Misc/Form';

import { useUserCreateStore } from 'store/user/useUserCreateStore';
import { Title } from 'components/Misc/Typography';

const Warrant = ({ gradeId, warrant }) => {
	// Use user's creation store
	const onRemoveStudentWarrant = useUserCreateStore(state => state.onRemoveStudentWarrant);

	// Handle warrant removal for student
	const onRemove = () => onRemoveStudentWarrant(gradeId, warrant.key);
	
	return (
		<div className="flex items-center rounded-lg space-x-2 dark:border-neutral-700">
			<Title
				title={warrant.name}
				subtitle="Rīkojuma nosaukums"
				className="flex-1"
			/>

			<Button
				small
				square
				icon="close"
				theme="danger"
				onClick={onRemove}
			/>
		</div>
	);
};

export default Warrant;